import { DeclarativeShadowElement } from '@theme/component';

export class OverflowMinimumEvent extends Event {
  constructor(minimumReached) {
    super('overflowMinimum', { bubbles: true });
    this.detail = { minimumReached };
  }
}

export class OverflowList extends DeclarativeShadowElement {
  static get observedAttributes() { return ['disabled']; }

  connectedCallback() {
    super.connectedCallback();
    this.#setup();
  }

  #setup() {
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot || this.#refs) return;

    const defaultSlot = shadowRoot.querySelector('slot:not([name])');
    const overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
    const moreSlot = shadowRoot.querySelector('slot[name="more"]');
    const list = shadowRoot.querySelector('[part="list"]');
    if (!(defaultSlot instanceof HTMLSlotElement) || !(overflowSlot instanceof HTMLSlotElement) || !(moreSlot instanceof HTMLSlotElement) || !(list instanceof HTMLUListElement)) return;

    this.#refs = { defaultSlot, overflowSlot, moreSlot, list };

    const style = document.createElement('style');
    style.textContent = `
      @media (min-width: 990px) {
        :host { display:block!important; width:max-content!important; max-width:100%!important; margin-inline:auto!important; }
        :host > ul[part="list"] {
          display:flex!important;
          flex-wrap:wrap!important;
          justify-content:center!important;
          align-items:center!important;
          gap:4px 18px!important;
          width:700px!important;
          max-width:100%!important;
          min-height:60px!important;
          margin:0 auto!important;
          padding:0!important;
          box-sizing:border-box!important;
          overflow:visible!important;
        }
        :host > ul[part="list"] > slot:not([name]) { display:contents!important; }
        :host > ul[part="list"] > slot:not([name])::slotted(.menu-list__list-item) {
          display:flex!important;
          width:auto!important;
          min-width:0!important;
          margin:0!important;
          padding:0!important;
          align-items:center!important;
          justify-content:center!important;
          white-space:nowrap!important;
        }
      }
    `;
    shadowRoot.appendChild(style);

    this.setAttribute('disabled', 'true');
    this.#reset();
  }

  attributeChangedCallback() {
    if (this.#refs && this.hasAttribute('disabled')) this.#reset();
  }

  #reset() {
    const { defaultSlot, overflowSlot, moreSlot, list } = this.#refs;
    for (const element of overflowSlot.assignedElements()) element.slot = defaultSlot.name;
    list.style.removeProperty('height');
    moreSlot.hidden = true;
    this.style.setProperty('--overflow-count', '0');
  }

  showAll() {
    this.setAttribute('disabled', 'true');
    this.#reset();
  }

  get defaultSlot() { return this.#refs?.defaultSlot; }
  get overflowSlot() { return this.#refs?.overflowSlot; }
  #refs;
}

if (!customElements.get('overflow-list')) customElements.define('overflow-list', OverflowList);
